module.exports = __webpack_public_path__ + "static/media/jo.8f719a67.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/jo.svg
// module id = 683
// module chunks = 0